import React, { Component } from 'react';
import SimpleSequencerBottomToolbar from "components/installation/SimpleSequencerBottomToolbar.js"
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import SidebarComponent from "components/sidebar/SidebarComponent.js";
import GroupEdges from "components/groups/GroupEdges.js";
import LinkedParameterVisualizer from "components/parameters/LinkedParameterVisualizer.js";
import GridsContainer from "components/mix/GridsContainer.js";
import SendsTrackComponent from 'components/track/SendsTrackComponent.js';
import NewGroupsComponent from './mix2/NewGroupsComponent.js';
import MixEffects from './mix2/MixEffects.js';
import MixTab from './MixTab.js';
import StepsVisualizer from './StepsVisualizer.js';
import TracksVisualizer from './TracksVisualizer.js';
import TrackQuickView from 'components/sidebar/TrackQuickView.js';
import Group from 'components/mix/Group.js';
import NewGroup from 'components/mix/NewGroup.js';
import GroupsComponent from 'components/mix/GroupsComponent.js';
import MixParametersComponent from 'components/mix/MixParametersComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import MixesComponent from 'components/mix/MixesComponent.js';
import { connect } from "react-redux";
import {setSelectedGroup} from 'actions/index.js';
import {setHideMixer} from 'actions/index.js';
import {setSelectedTrack} from 'actions/index.js';
import {setSelectedParameter} from 'actions/index.js';
import {setSelectedParameterFlashing} from 'actions/index.js';
import MixEffectsPane from 'components/mix/MixEffectsPane.js';
import GroupMuteButton from 'components/mix/GroupMuteButton.js';
import Sample from 'repos/Sample.js';
import EffectComponents from 'components/effects/EffectsComponent.js';
import SendComponent from 'components/mix/SendComponent.js';
import SubMixComponent from './SubMixComponent.js';
import {HIDE, MIXES} from 'components/mix/constants.js';
import '../../Mix.scss';

/**
 * Mode for mixing sounds by groups easily, similar to the mix view in ableton
 */
class Mix extends Component {
    constructor(props) {
        super(props);

        this.state = {
            scale: 1,
            selectedGroup: undefined,
            renders: 0,
            pattern: props.sequencerEngine.currentPattern
        };

        // this.props.setSelectedTrack(props.sequencerEngine.cursor.track);
        
        this.sequencerEngine = props.sequencerEngine;

        this.onDrop = this.onDrop.bind(this);
        this.ref = React.createRef();
    }

    get groups() {
        return this.sequencerEngine.groups;
    }

    // plays or stops the sequencer
    onClickPlayStop() {
        this.sequencerEngine.play();
        this.setState(this.state);
    }

    onParameterChanged(parameter) {
        this.props.setSelectedParameter(parameter);
        this.props.setSelectedParameterFlashing(parameter);
        setTimeout(() => {
            this.props.setSelectedParameterFlashing(undefined);
        }, 3000);
    }

    get hide() {
        return this.props.effectsPaneOption === HIDE ||
            this.props.mixViewMode === MIXES;
    }

    onDrop(e) {
        let state = this.props.sequencerEngine.state;
        if (state.sequencer.effectDragging) {
            return;
        }
        let trackDragging = state.mix.trackDragging;
        this.props.sequencerEngine.groups.newGroup(
            trackDragging);
    }

    toggleHide() {
        this.props.setHideMixer(
            !this.props.hideMixer);
    }

    render() {
        if (this.props.showingPiano) {
            console.log('showing piano');
            return (<SimpleSequencerBottomToolbar sequencerEngine={this.props.sequencerEngine}/>);
        }
        return (
            <div className="full-view">
              <div ref={this.ref} className={this.props.mixViewMode === MIXES ? "mixes mix-view" : "mix-view"}>
                <GroupEdges scrollContainer={this.ref} sequencerEngine={this.props.sequencerEngine}/>
                <LinkedParameterVisualizer
                  scale={this.state.scale}
                  scrollContainer={this.ref}/>
                <ConditionedComponent
                  condition={this.props.sequencerEngine.tracks.length > 0}>
                  <MixTab sequencerEngine={this.props.sequencerEngine}/>
                  <MixParametersComponent
                    isMixView={true}
                    sequencerEngine={this.props.sequencerEngine}
                    lfosTrack={this.props.sequencerEngine.lfosTrack}/>
                </ConditionedComponent>
                <ConditionedComponent
                  condition={this.props.mixViewMode === MIXES}>
                  <GridsContainer 
                    scale={this.state.scale}
                    setScale={(x) => this.setState({scale: x})}
                    sequencerEngine={this.props.sequencerEngine}/>
                </ConditionedComponent>
                <div
                  onDrop={this.onDrop}
                  className={this.hide ? "channel-mixer lower" : "channel-mixer"}>
                  {this.props.hideMixer && this.props.mixViewMode === MIXES ? "" : 
                   <div className="channel-mixer-parts">
                     <div className="groups-container" id="mix-scroll">
                       <ConditionedComponent
                         condition={this.props.mixViewMode !== MIXES}>
                         <NewGroupsComponent sequencerEngine={this.sequencerEngine}/>
                       </ConditionedComponent>
                       <ConditionedComponent
                         condition={this.props.mixViewMode === MIXES}>
                         <SubMixComponent sequencerEngine={this.props.sequencerEngine}/>
                       </ConditionedComponent>
                     </div>
                     <SendsTrackComponent sequencerEngine={this.props.sequencerEngine}/>
                   </div>}
                  {this.props.mixViewMode === MIXES && 
                  <div className="mix-bottom-bar">
                    <div onClick={() => this.toggleHide()} className="collapse-button">
                      {this.props.hideMixer ?
                       <div className="arrow-right"/> :
                       <div className="arrow-up"/>}
                    </div>
                  </div>}
                </div>
              </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedTrack: track => dispatch(setSelectedTrack(track)),
        setHideMixer: x => dispatch(setHideMixer(x)),
        setSelectedGroup: group => dispatch(setSelectedGroup(group)),
        setSelectedParameter: parameter => dispatch(setSelectedParameter(parameter)),
        setSelectedParameterFlashing: parameter => dispatch(setSelectedParameterFlashing(parameter))
    }
};

const mapStateToProps = (state, props) => {
    let bottomMode = state.arrangement.bottomMode;
    let showingPiano = state.sequencer.showPianoRoll && bottomMode === PIANO_ROLL;
    return {
        showingPiano,
        effectsPaneOption: state.mix.effectsPaneOption,
        currentSubSequence: state.sequencer.currentSubSequence[props.sequencerEngine.engineId],
        mixViewMode: state.mix.mixViewMode,
        hideMixer: state.mix.hideMixer
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Mix);
